import { FLEX_BASE_ROUTE, TABS } from '@/src/utils/constants'
import React, { Suspense } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../routes/routes.components'

const FlexSectorCouplingLazy = React.lazy(() => import('./FlexSectorCoupling'))
const FlexBatteryControlLazy = React.lazy(() => import('./FlexBatteryControl'))

const SectorCouplingPage = (
  <Suspense fallback={<div />}>
    <FlexSectorCouplingLazy />
  </Suspense>
)

const BatteryControlPage = (
  <Suspense fallback={<div />}>
    <FlexBatteryControlLazy />
  </Suspense>
)

export const getFlexRoutes = (): RouteObject[] => {
  const defaultRedirection = TABS.flex.sectorCoupling

  return [
    {
      path: FLEX_BASE_ROUTE,
      element: (
        <AuthRoute>
          <LayoutMain />
        </AuthRoute>
      ),
      children: [
        { path: '', element: <Navigate to={defaultRedirection} replace />, index: true },
        {
          path: TABS.flex.sectorCoupling,
          element: SectorCouplingPage,
          children: [{ path: '', element: SectorCouplingPage }],
        },
        {
          path: TABS.flex.batteryControl,
          element: BatteryControlPage,
          children: [{ path: '', element: BatteryControlPage }],
        },
      ],
    },
  ]
}
